import React, { Fragment, useState, useEffect } from "react";
import Breadcrumb from "../common/breadcrumb";
import Datatable from "../common/datatable";
import { Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
import axios from "axios";

const Orders = () => {
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const [orderItems, setOrderItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const sellerId = localStorage.getItem("seller_id");

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const { data } = await axios(
        `${baseUrl}/seller/${sellerId}/order-items/`
      );
      setOrderItems(data.data || []);
    } catch (error) {
      console.error("Error fetching orders:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Fragment>
      <Breadcrumb title="Orders" parent="Sales" />

      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <CardHeader>
                <h5>Manage Orders</h5>
              </CardHeader>
              <CardBody className="order-datatable">
                {loading ? (
                  <div className="text-center p-4">
                    <span
                      className="spinner-border text-primary"
                      role="status"
                      aria-hidden="true"
                      style={{ width: "2rem", height: "2rem" }}
                    ></span>
                    <div className="mt-2">Loading orders...</div>
                  </div>
                ) : orderItems.length === 0 ? (
                  <div className="text-center p-4">No orders found.</div>
                ) : (
                  <Datatable
                    myData={orderItems}
                    myClass="-striped -highlight"
                    pagination={true}
                  />
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default Orders;
